<!-- SearchField.svelte -->
<script lang="ts">
    import Select from 'svelte-select';

    import { createEventDispatcher } from 'svelte'
    const dispatch = createEventDispatcher()
    export let value = ''
    export let id  = "search-field"
    export let placeholder = ""
    export let fieldlabel = ""

    // export let items
    export const  itemId = 'id';
    export const label = 'title';

</script>


    <label class="sr-only" for="{id}"><strong>{fieldlabel}</strong></label>

    <input
        type="text"
        class="form-control"
        id="{id}"
        placeholder="{placeholder}"
        autocomplete="off"
        bind:value
        on:input={dispatch("searchtext", value)}
    />


<style>
</style>
